import { t } from '@lingui/core/macro';
import { withFilterErrorBoundary } from './FilterErrorBoundary';
import { StringArrayFilter } from './StringArrayFilter';
import { useGetUsers } from './useGetUsers/useGetUsers';
export const allowedUsersFilterLabel = () => t({ message: 'User access', comment: 'Insights filter: Users with access' });
/**
 * Filtering users with access to FilSystemEntries.
 */
export const AllowedUsersFilter = withFilterErrorBoundary(() => {
    const { data, error, loading } = useGetUsers();
    const disabled = Boolean(loading || error);
    return <StringArrayFilter name="allowedUsers" items={data} label={allowedUsersFilterLabel()} loading={disabled}/>;
});
